import { Config } from "@/config";
import { ApiResponseForArticleList, ApiResponseForFaqSearch, ApiResponseForHelp, ApiResponseForRecommend } from "@/interfaces/help";
import { ApiResponse } from "@/interfaces/search";
import axios from "axios";


/// shop
export const GetHelpSearchArticleFaq = async (keyword: string): Promise<ApiResponseForFaqSearch> => {
    try {
        const response = await axios<ApiResponseForFaqSearch>({
            method: "get",
            maxBodyLength: Infinity,
            url: `${Config.apiEndpoint}help-center/search-article-faq?keyword=${keyword}`,
            headers: {
                Authorization: `Basic ${Config.encoded}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response) {
                console.error('Error response:', error.response);
                return error.response.data;
            }
            console.error('Error message:', error.message);
        } else {
            console.error('Unexpected error:', error);
        }
        return { success: false, data: [] };
    }
};

export const GetHelpListCategory = async (): Promise<ApiResponseForHelp> => {
    try {
        const response = await axios<ApiResponseForHelp>({
            method: 'get',
            maxBodyLength: Infinity,
            url: `${Config.apiEndpoint}help-center/get-list-category`,
            headers: {
                'Content-Type': 'application/json',
                Authorization: "Basic " + "your_encoded_token",
            },
        });

        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response) {
                console.error('Error response:', error.response);
                return { success: false, data: [], error: error.response.data.message || 'An error occurred' };
            }
            console.error('Error message:', error.message);
            return { success: false, data: [], error: error.message };
        } else {
            console.error('Unexpected error:', error);
            return { success: false, data: [], error: 'An unexpected error occurred' };
        }
    }
};

export const GetHelpRecommend = async (): Promise<ApiResponseForRecommend> => {
    try {
        const response = await axios<ApiResponseForRecommend>({
            method: 'get',
            maxBodyLength: Infinity,
            url: `${Config.apiEndpoint}help-center/get-list-article-recommend`,
            headers: {
                Authorization: 'Basic ' + Config.encoded,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response) {
                console.error('Error response:', error.response);
                return error.response.data;
            }
            console.error('Error message:', error.message);
        } else {
            console.error('Unexpected error:', error);
        }
        return { success: false, data: [] }; // Return a default value in case of error
    }
};

export const GetHelpArticleDetail = async (slug: string | string[] | undefined): Promise<ApiResponseForFaqSearch> => {
    try {
        const response = await axios<ApiResponseForFaqSearch>({
            method: "get",
            maxBodyLength: Infinity,
            url: `${Config.apiEndpoint}help-center/get-article-detail-faq/${slug}`,
            headers: {
                Authorization: `Basic ${Config.encoded}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response) {
                console.error('Error response:', error.response);
                return error.response.data;
            }
            console.error('Error message:', error.message);
        } else {
            console.error('Unexpected error:', error);
        }
        return { success: false, data: [] }; // คืนค่า default เมื่อเกิดข้อผิดพลาด
    }
};

export const GetHelpListArticleFaq = async (slug: string | string[] | undefined): Promise<ApiResponseForArticleList> => {

    try {
        const response = await axios<ApiResponseForArticleList>({
            method: "get",
            maxBodyLength: Infinity,
            url: `${Config.apiEndpoint}help-center/get-list-article-faq/${slug}`,
            headers: {
                Authorization: `Basic ${Config.encoded}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response) {
                console.error('Error response:', error.response);
                return error.response.data;
            }
            console.error('Error message:', error.message);
        } else {
            console.error('Unexpected error:', error);
        }
        return { success: false, data: [] }; 
    }
};


/// seller 
export const GetHelpSellerSearchArticleFaq = async (keyword: string): Promise<ApiResponseForFaqSearch> => {
    try {
        const response = await axios<ApiResponseForFaqSearch>({
            method: "get",
            maxBodyLength: Infinity,
            url: `${Config.apiEndpoint}help-seller-center/search-article-faq?keyword=${keyword}`,
            headers: {
                Authorization: `Basic ${Config.encoded}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response) {
                console.error('Error response:', error.response);
                return error.response.data;
            }
            console.error('Error message:', error.message);
        } else {
            console.error('Unexpected error:', error);
        }
        return { success: false, data: [] }; // คืนค่า default เมื่อเกิดข้อผิดพลาด
    }
};

export const GetHelpSellerListCategory = async (): Promise<ApiResponseForHelp> => {
    try {
        const response = await axios<ApiResponseForHelp>({
            method: 'get',
            maxBodyLength: Infinity,
            url: `${Config.apiEndpoint}help-seller-center/get-list-category`,
            headers: {
                'Content-Type': 'application/json',
                Authorization: "Basic " + "your_encoded_token",
            },
        });

        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response) {
                console.error('Error response:', error.response);
                return { success: false, data: [], error: error.response.data.message || 'An error occurred' };
            }
            console.error('Error message:', error.message);
            return { success: false, data: [], error: error.message };
        } else {
            console.error('Unexpected error:', error);
            return { success: false, data: [], error: 'An unexpected error occurred' };
        }
    }
};

export const GetHelpSellerRecommend = async (): Promise<ApiResponseForRecommend> => {
    try {
        const response = await axios<ApiResponseForRecommend>({
            method: 'get',
            maxBodyLength: Infinity,
            url: `${Config.apiEndpoint}help-seller-center/get-list-article-recommend`,
            headers: {
                Authorization: 'Basic ' + Config.encoded,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response) {
                console.error('Error response:', error.response);
                return error.response.data;
            }
            console.error('Error message:', error.message);
        } else {
            console.error('Unexpected error:', error);
        }
        return { success: false, data: [] }; // Return a default value in case of error
    }
};

export const GetHelpSellerArticleDetail = async (slug: string | string[] | undefined): Promise<ApiResponseForFaqSearch> => {
    try {
        const response = await axios<ApiResponseForFaqSearch>({
            method: "get",
            maxBodyLength: Infinity,
            url: `${Config.apiEndpoint}help-seller-center/get-article-detail-faq/${slug}`,
            headers: {
                Authorization: `Basic ${Config.encoded}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response) {
                console.error('Error response:', error.response);
                return error.response.data;
            }
            console.error('Error message:', error.message);
        } else {
            console.error('Unexpected error:', error);
        }
        return { success: false, data: [] }; // คืนค่า default เมื่อเกิดข้อผิดพลาด
    }
};

export const GetHelpSellerListArticleFaq = async (slug: string | string[] | undefined): Promise<ApiResponseForArticleList> => {

    try {
        const response = await axios<ApiResponseForArticleList>({
            method: "get",
            maxBodyLength: Infinity,
            url: `${Config.apiEndpoint}help-seller-center/get-list-article-faq/${slug}`,
            headers: {
                Authorization: `Basic ${Config.encoded}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response) {
                console.error('Error response:', error.response);
                return error.response.data;
            }
            console.error('Error message:', error.message);
        } else {
            console.error('Unexpected error:', error);
        }
        return { success: false, data: [] }; // คืนค่า default เมื่อเกิดข้อผิดพลาด
    }
};


export const GetSeartch = async (keyword: string ) => {
  try {
   
    const data = await axios<ApiResponse>({
      method: "get",
      maxBodyLength: Infinity,
      url:
        Config.apiEndpoint +
        `help-center/search-article-faq?keyword=${keyword}`,
      headers: {
        // "x-access-token": token,
        Authorization: "Basic " + Config.encoded,
        "Content-Type": "application/json"
      }
    });
    return data as any;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      error = error.response;
      return error;
    }
  }
};